import { formatDayToMonth, formatDayToYearShorter } from 'utils/date/format.util';
import withOptions from 'utils/functions/withOptions.util';

const determinePaymentsReportPeriodText = withOptions(({ bgn: bgnFromOptions, end: endFromOptions }) => {
  const bgn = formatDayToYearShorter(bgnFromOptions);
  const end = formatDayToYearShorter(endFromOptions);

  return bgn === end ? bgn : `${formatDayToMonth(bgnFromOptions)} - ${end}`;
});

export default determinePaymentsReportPeriodText;
